export default __webpack_public_path__ + "static/image-6-6b5c56a2ec252a4cc6e6a5f6e15a3384.jpg";